module.exports = __webpack_public_path__ + "static/img/Toby-Rudolf.3fb090e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Toby-Rudolf.jpg
// module id = bo5E
// module chunks = 0